import { apiSlice } from "../api/apiSlice";
import { EditDone } from "../Edit/EditSlice";

export const QuizApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getQuizAndMark: builder.query({
            async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
                /// check this video have quiz 
                const quizzes = await fetchWithBQ(`quizzes?video_id=${arg.videoId}`);
                if (quizzes.error) return { error: quizzes.error };
                // check this user participated or not 
                const quizMark = await fetchWithBQ(
                    `quizMark?video_id=${arg.videoId}&student_id=${arg.studentId}`
                );

                return {
                    data: {
                        isQuiz: !!quizzes?.data?.length,
                        isQuizMark: !!quizMark?.data?.length,
                        quizzes: quizzes?.data,
                        quizMark: quizMark?.data[0]
                    },
                };
            },
            providesTags: (result, error, arg) => [
                { type: "QuizzesAndMark", id: arg.videoId },
            ]
        }),
        getQuizzesMark: builder.query({
            query: () => ({
                url: "/quizMark",
            }),
            providesTags: ["QuizzesMark"]
        }),
        quizParticipate: builder.mutation({
            query: (data) => ({
                url: `/quizMark`,
                method: "POST",
                body: data
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "QuizzesAndMark", id: arg.videoId },
                "QuizzesMark",

            ]

        }),


        // admin api start
        getQuizzesForAdmin: builder.query({
            query: () => ({
                url: "/quizzes"
            }),
            providesTags: ["QuizzesForAdmin"]
        })
        ,
        deleteQuiz: builder.mutation({
            query: (id) => ({
                url: `/quizzes/${id}`,
                method: "DELETE"
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic quizzes cache update
                try {
                    await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getQuizzesForAdmin", undefined, (draft) => {
                            return draft.filter(item => item.id !== arg)
                        })
                    )
                } catch (err) {
                    // do nothing
                }
            },
        }),
        addQuiz: builder.mutation({
            query: (data) => ({
                url: "/quizzes",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic videos cache update
                try {
                    const res = await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getQuizzesForAdmin", undefined, (draft) => {
                            draft.push(res.data);
                        })
                    );
                } catch (err) {
                    // do nothing
                }
            },
        }),
        editQuiz: builder.mutation({
            query: ({ id, data }) => ({
                url: `/quizzes/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                // pessimistic videos cache update
                try {
                    const res = await queryFulfilled;
                    dispatch(EditDone);
                    dispatch(
                        apiSlice.util.updateQueryData("getQuizzesForAdmin", undefined, (draft) => {
                            return draft.map(item => {
                                if (Number(item.id) === Number(arg.id)) {
                                    return { ...res.data }
                                } else {
                                    return item
                                }
                            })
                        })
                    );
                } catch (err) {
                    // do nothing
                }
            },
        }),
    }),
});

export const {
    useGetQuizAndMarkQuery,
    useGetQuizzesQuery,
    useGetQuizzesMarkQuery,
    useQuizParticipateMutation,
    useGetQuizzesForAdminQuery,
    useDeleteQuizMutation,
    useAddQuizMutation,
    useEditQuizMutation
} = QuizApi;